import { render, staticRenderFns } from "./ConfigurePriceReductionModal.vue?vue&type=template&id=f5e22b48&scoped=true"
import script from "./ConfigurePriceReductionModal.vue?vue&type=script&lang=js"
export * from "./ConfigurePriceReductionModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigurePriceReductionModal.vue?vue&type=style&index=0&id=f5e22b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e22b48",
  null
  
)

export default component.exports